import ShiftModel from '../models/ShiftModel';

export default class ShiftCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = ShiftModel;
  }

  url() {
    // hardcoded fake url at this point, real endpoints will be added
    // and environemnt specific api locations will be set up in the config.rb
    return `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
      + appConstants.ApiPaths.API_VERSION_PATH}/departments/1/shifts`;
  }

  parse(data) {
    return data.shifts ? data.shifts : data;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_SHIFTS:
        Utils.setMakeshiftTokenHeader();
        // if (ShiftStore.models.length == 0) {
        ShiftStore.fetch({
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
            + appConstants.ApiPaths.API_VERSION_PATH
            + appConstants.EndPoints.SHIFTS_PATH,
          type: 'GET',
          data: payload.postData,
          success: ShiftStore.onShiftsHandler,
          error: ShiftStore.onShiftsError,
        });
        // } else {
        // ShiftStore.trigger('shifts:load:success');
        // }
        break;
      case ActionTypes.GET_ALL_SHIFTS:
        Utils.setMakeshiftTokenHeader();
        // if (ShiftStore.models.length == 0) {
        ShiftStore.fetch({
          remove: false,
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
            + appConstants.ApiPaths.API_VERSION_PATH
            + appConstants.EndPoints.SHIFTS_PATH,
          type: 'GET',
          data: payload.postData,
          success: ShiftStore.onAllShiftsHandler,
          error: ShiftStore.onAllShiftsError,
        });
        // } else {
        // ShiftStore.trigger('shifts:load:success');
        // }
        break;
      case ActionTypes.GET_SHIFT_BY_ID:
        Utils.setMakeshiftTokenHeader();
        var url = `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.SHIFTS_PATH}/%d`;
        var shiftByIDURL = url.replace(
          '%d',
          payload.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')],
        );
        $.ajax({
          method: 'GET',
          url: shiftByIDURL,
          success: ShiftStore.onShiftByIDHandler,
          error: ShiftStore.onShiftByIDError,
        });
        break;
      case ActionTypes.GET_SHIFT_BY_DATE:
        Utils.setMakeshiftTokenHeader();
        $.ajax({
          method: 'GET',
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
            + appConstants.ApiPaths.API_VERSION_PATH
            + appConstants.EndPoints.SHIFTS_PATH,
          contentType: 'application/json',
          data: payload.postData,
          success: ShiftStore.onShiftByDateHandler,
          error: ShiftStore.onShiftByDateError,
        });
        break;
      case ActionTypes.CLEAR_CALENDAR:
        Utils.setMakeshiftTokenHeader();
        ShiftStore.trigger(appConstants.ActionTypes.CLEAR_CALENDAR);
        break;
      case ActionTypes.CREATE_SHIFT:
        // schedulerData is undefined here and doesn't seem to be used anywhere
        // will assume this is unused code and should be deleted in the year 2020
        // ShiftStore.create(
        //   { shift: payload.data.shift },
        //   {
        //     wait: true,
        //     url: `/departments/${schedulerData.departmentId}/shifts`,
        //     success: ShiftStore.successCallback,
        //     error: ShiftStore.failureCallback,
        //   },
        // );
        break;
      case ActionTypes.DELETE_SHIFT:
        Utils.setMakeshiftTokenHeader();
        var { shift } = payload.data;
        shift_store = ShiftStore.get(shift);
        shift_store.destroy({
          wait: true,
          url: `/shifts/${shift.id}`,
          success: ShiftStore.deleteSuccessCallback,
        });
        break;
      case ActionTypes.UPDATE_SHIFT:
        Utils.setMakeshiftTokenHeader();
        var { shift } = payload.data;
        var { update_params } = payload.data;
        var shift_store = ShiftStore.get(shift.id);
        shift_store.save(update_params, {
          patch: true,
          wait: true,
          url: `/shifts/${shift.id}`,
          success: ShiftStore.updateSuccessCallback,
          error: ShiftStore.updateErrorCallback,
        });
        break;

      default:
        break;
    }
  }
}
